import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
	marginLeft: `calc(${theme.spacing(1)} - 2px)`,
	animation: 'none',
}));
